/* Le Chic Beauty storefront helpers.
   Product data lives in js/catalog.js, generated from the Le Chic Beauty master sheet
   (names, MSRP, copy, features, directions, ingredients) with product images
   from lechicbeauty.com. Cost and inventory data are never exported. */
window.LC = window.LC || {};

// Products taken off the site (keep in sync with $retired in build/build-site.ps1)
LC.retiredIds = ['helix-infrared-styler', 'thermal-fusion-infrared-blow-dryer', 'zephyr-salon-turbo-blow-dryer', 'super-curl-automatic-curler'];

LC.products = (window.LC_CATALOG || []).filter((p) => !LC.retiredIds.includes(p.id)).map((p) => Object.assign({
  price: null,
  optionLabel: 'Color',
  options: [],
  images: [],
  description: '',
  features: [],
  benefits: [],
  highlights: [],
  directions: [],
  ingredients: null,
  videos: []
}, p));

LC.collections = {
  all: {
    name: 'Shop All',
    tagline: 'The complete Le Chic Beauty edit',
    description: 'Professional styling tools, repairing hair care, extensions and accessories for polished, salon-inspired results at home.',
    image: 'images/h-1.jpg',
    imageAlt: 'Elodie in a pale blue tweed dress and beret on a Paris balcony'
  },
  // ----- The four signature collections (homepage, menu, footer) -----
  tools: {
    name: 'Hair Tools',
    eyebrow: 'Heat, perfected',
    tagline: 'Heat, perfected',
    description: 'Infrared flat irons, blow dryers, curling wands and travel minis for salon-quality results at home.',
    image: 'images/t-iron.jpg',
    imageAlt: 'Woman with long blonde hair using a black flat iron',
    includes: ['flat-irons', 'blow-dryers', 'curling', 'travel', 'grooming'],
    excludeIds: ['le-chic-beard-oil']
  },
  care: {
    name: 'Hair Care',
    eyebrow: 'The ritual',
    tagline: 'Repair, nourish, glow',
    description: 'The Repairing Caviar collection and finishing treatments, formulated to leave hair soft, strong and luminous.',
    image: 'images/cg-6.jpg',
    imageAlt: 'Colette with a glossy silver bob, in ivory knit and pearls',
    includes: ['hair-care', 'treatments'],
    alsoIds: ['le-chic-beard-oil']
  },
  // ----- Sub-collections -----
  'flat-irons': {
    name: 'Flat Irons',
    tagline: 'Sleek, smooth, polished',
    description: 'Infrared, titanium and ceramic flat irons designed to straighten, wave and curl.',
    image: 'images/t-iron.jpg',
    imageAlt: 'Woman with long blonde hair using a black flat iron'
  },
  'blow-dryers': {
    name: 'Blow Dryers & Brushes',
    tagline: 'The at-home blowout',
    description: 'Infrared blow dryers and blow dryer brushes that dry and style for a smooth, glossy finish.',
    image: 'images/t-dryer.jpg',
    imageAlt: 'Woman with a dark bob smiling while using a black hair dryer'
  },
  curling: {
    name: 'Curling Wands',
    tagline: 'Waves, curls & everything between',
    description: 'Twister wands, an interchangeable curling set and an automatic curler for every curl preference.',
    image: 'images/t-wand.jpg',
    imageAlt: 'Colette curling her silver hair with a curling wand'
  },
  travel: {
    name: 'Petite & Travel',
    tagline: 'Good hair, anywhere',
    description: 'Compact straighteners and a mini blow dryer brush made for touch-ups and travel.',
    image: 'images/cg-2.jpg',
    imageAlt: 'Elodie in sunglasses outside a Paris doorway'
  },
  'hair-care': {
    name: 'Repairing Caviar',
    tagline: 'The caviar ritual',
    description: 'Shampoo, conditioner, mask and serum formulated with caviar extract, keratin and botanical oils.',
    image: 'images/m-chloe.jpg',
    imageAlt: 'Chloe with long, glossy golden waves'
  },
  treatments: {
    name: 'Treatments & Finishing',
    tagline: 'The next Le Chic Beauty rituals',
    description: 'Blue Copper, Diamond Infusion, Mermaid Tears and the 10-Second Speed Repair Mask, in Le Chic Beauty’s navy and icy blue packaging. Pricing coming soon.',
    image: 'images/c-blue-copper.jpg',
    imageAlt: 'Blue Copper Split-End Mender and Scalp Renewal Serum'
  },
  extensions: {
    name: 'Hair Extensions',
    eyebrow: 'Length & volume',
    tagline: 'Length & volume, no commitment',
    description: '100% Remy human hair halo and clip-in extensions in a wide range of shades.',
    image: 'images/cg-1.jpg',
    imageAlt: 'Vivienne with long, glossy honey-blonde hair'
  },
  accessories: {
    name: 'Accessories',
    eyebrow: 'The finishing touch',
    tagline: 'The finishing essentials',
    description: 'Combs, brushes, heat mats and tool holders to complete your styling station.',
    image: 'images/t-ritual.jpg',
    imageAlt: 'Two women styling their hair together at a bathroom mirror'
  },
  grooming: {
    name: 'Grooming',
    tagline: 'For him',
    description: 'Beard styling and care with the same Le Chic Beauty attention to detail.',
    image: null,
    imageAlt: 'Le Chic Beauty grooming'
  }
};

// Search-led headings and metadata for every collection page (SEO + GEO)
LC.collectionSeo = {
  all: {
    h1: 'Shop All Le Chic Beauty Products',
    title: 'Shop Hair Tools, Hair Care & Hair Extensions | Le Chic Beauty',
    meta: 'Shop every Le Chic Beauty product: infrared flat irons, blow dryers, curling wands, Repairing Caviar hair care, Remy human hair extensions and accessories.',
    intro: 'Explore the full Le Chic Beauty collection: infrared and ceramic flat irons, blow dryers and blow dryer brushes, curling wands, Repairing Caviar hair care, 100% Remy human hair extensions and styling accessories.'
  },
  tools: {
    h1: 'Professional Hair Styling Tools',
    title: 'Hair Styling Tools: Infrared Flat Irons, Dryers & Curlers | Le Chic Beauty',
    meta: 'Shop Le Chic Beauty professional hair tools: infrared flat irons, blow dryers, blow dryer brushes, curling wands and travel straighteners. Lifetime warranty when registered.',
    intro: 'Le Chic Beauty hair styling tools use far infrared heat, negative ion technology and titanium, ceramic or tourmaline surfaces to straighten, curl and blow-dry hair for a smooth, glossy, salon-quality finish at home.'
  },
  care: {
    h1: 'Hair Care & Repair Treatments',
    title: 'Caviar Hair Care, Hair Masks & Serums | Le Chic Beauty',
    meta: 'Shop Le Chic Beauty hair care: Repairing Caviar shampoo, conditioner, hair mask and serum with caviar extract, keratin and argan oil, plus repair and finishing treatments.',
    intro: 'Le Chic Beauty hair care is built around the Repairing Caviar ritual: a sulfate-free shampoo, conditioner, weekly hair mask and finishing serum made with caviar extract, keratin, biotin and argan oil for soft, smooth, polished hair.'
  },
  'flat-irons': {
    h1: 'Infrared, Titanium & Ceramic Flat Irons',
    title: 'Infrared Flat Irons & Hair Straighteners | Le Chic Beauty',
    meta: 'Shop Le Chic Beauty flat irons with far infrared heat, floating titanium or ceramic plates and negative ion technology to straighten, wave and curl hair.',
    intro: 'Le Chic Beauty flat irons pair far infrared heat with floating titanium or ceramic plates and negative ion technology to straighten, wave and curl hair with less frizz and more shine.'
  },
  'blow-dryers': {
    h1: 'Infrared Blow Dryers & Blow Dryer Brushes',
    title: 'Infrared Blow Dryers & Blow Dryer Brushes | Le Chic Beauty',
    meta: 'Shop Le Chic Beauty infrared hair dryers and 2-in-1 blow dryer brushes that dry and style at once for a smooth, glossy, frizz-free blowout at home.',
    intro: 'Le Chic Beauty infrared blow dryers and blow dryer brushes dry and style in one step, using infrared heat and negative ions to reduce frizz and leave hair smooth, glossy and full of volume.'
  },
  curling: {
    h1: 'Curling Wands & Automatic Hair Curlers',
    title: 'Curling Wands & Automatic Hair Curlers | Le Chic Beauty',
    meta: 'Shop Le Chic Beauty curling irons: clip-free Twister curling wands in 0.5" to 1.25" barrels, the Bella Twist interchangeable wand and the Super Curl automatic curler.',
    intro: 'From tight, defined curls to soft, loose waves, Le Chic Beauty curling wands come in clip-free barrel sizes from 0.5" to 1.25", plus an interchangeable curling set and an automatic curler.'
  },
  travel: {
    h1: 'Travel Hair Tools & Mini Straighteners',
    title: 'Mini Travel Hair Straighteners & Dryer Brushes | Le Chic Beauty',
    meta: 'Shop compact Le Chic Beauty travel hair tools: a mini ceramic straightener, a portable ionic straightening brush and a mini blow dryer brush for touch-ups on the go.',
    intro: 'Compact, lightweight Le Chic Beauty travel tools fit in a handbag or carry-on for touch-ups, bangs, bobs and short hair wherever your day takes you.'
  },
  'hair-care': {
    h1: 'Repairing Caviar Hair Care Collection',
    title: 'Repairing Caviar Shampoo, Conditioner, Mask & Serum | Le Chic Beauty',
    meta: 'Shop the Le Chic Beauty Repairing Caviar collection: sulfate- and paraben-free shampoo, conditioner, hair mask and serum with caviar extract, keratin and argan oil.',
    intro: 'The Repairing Caviar collection is a four-step hair care ritual for dry, damaged hair: cleanse, condition, treat and finish with caviar extract, keratin, biotin and argan oil.'
  },
  treatments: {
    h1: 'Hair Treatments & Finishing Products',
    title: 'Hair Repair Treatments, Serums & Hair Mist | Le Chic Beauty',
    meta: 'Discover Le Chic Beauty hair treatments: Blue Copper split-end mender and scalp serum, Diamond Infusion serum and mask, Mermaid Tears mist and a 10-second repair mask.',
    intro: 'Le Chic Beauty treatments target specific hair goals: Blue Copper peptides for split ends and scalp care, Diamond Infusion for polished shine, Mermaid Tears for an iridescent glow and a 10-second speed repair mask.'
  },
  extensions: {
    h1: '100% Remy Human Hair Extensions',
    title: 'Remy Human Hair Halo & Clip-In Extensions | Le Chic Beauty',
    meta: 'Shop Le Chic Beauty 100% Remy human hair extensions: halo extensions in 14–16" and 16–18" and clip-in extensions in 18" and 22", in 28 shades. No glue or heat.',
    intro: 'Le Chic Beauty hair extensions are made from 100% Remy human hair and come as halo extensions (14–16" and 16–18") or clip-in extensions (18" and 22") in 28 shades, for instant length and volume with no glue, chemicals or heat.'
  },
  accessories: {
    h1: 'Hair Styling Accessories',
    title: 'Heat Mats, Hot Tool Holders, Combs & Brushes | Le Chic Beauty',
    meta: 'Shop Le Chic Beauty hair accessories: a 450°F heat mat and storage pouch, the Glacière hot tool holder, a V-shaped chase comb and a vented detangling brush.',
    intro: 'Le Chic Beauty accessories complete your styling station: heat-resistant mats and holders to protect surfaces from hot tools, plus combs and brushes for detangling and sleek, straight styling.'
  },
  grooming: {
    h1: 'Men’s Grooming: Beard Straightener & Beard Oil',
    title: 'Beard Straightener Brush & Beard Oil | Le Chic Beauty',
    meta: 'Shop Le Chic Beauty men’s grooming: the Rocco beard straightener brush for smoothing and shaping facial hair, and Le Chic Beauty beard oil.',
    intro: 'Le Chic Beauty grooming brings the same attention to detail to facial hair, with a heated beard straightener brush and beard oil.'
  }
};

// Four signature collections; tools and care break down into sub-collections
LC.collectionOrder = ['tools', 'care', 'accessories', 'extensions'];
LC.homeCollectionOrder = LC.collectionOrder;
LC.subcollections = {
  tools: ['flat-irons', 'blow-dryers', 'curling', 'travel'],
  care: ['hair-care', 'treatments']
};

// Homepage best sellers: hair care in the navy and icy-blue Le Chic Beauty packaging only
LC.featuredIds = [
  'repairing-caviar-shampoo',
  'repairing-caviar-conditioner',
  'repairing-caviar-hair-mask',
  'blue-copper-scalp-renewal-serum',
  'diamond-infusion-hair-serum',
  '10-second-speed-repair-mask',
  'blue-copper-split-end-mender',
  'diamond-infusion-deep-repair-mask'
];

// Short, brand-voice lines for the homepage best sellers (drawn from packaging and store copy)
LC.featureCopy = {
  'repairing-caviar-shampoo': { badge: 'Caviar', line: 'A sulfate-free cleanse with caviar and keratin.' },
  'repairing-caviar-conditioner': { badge: 'Caviar', line: 'Softness, bottled. With caviar and argan oil.' },
  'repairing-caviar-hair-mask': { badge: 'Caviar', line: 'Your weekly dose of hair couture.' },
  'blue-copper-scalp-renewal-serum': { badge: 'New', line: 'Stronger roots. Fast-absorbing.' },
  'diamond-infusion-hair-serum': { badge: 'New', line: 'Polished shine, weightless finish.' },
  '10-second-speed-repair-mask': { badge: 'New', line: 'Salon repair in 10 seconds.' },
  'blue-copper-split-end-mender': { badge: 'New', line: 'Seals split ends. No rinse.' },
  'diamond-infusion-deep-repair-mask': { badge: 'New', line: 'A flawless, red-carpet finish.' }
};

// Coming-soon / not-yet-stocked care line — Caviar is in stock and buyable (removed 2026-09-28)
LC.soldOutIds = [
  'blue-copper-split-end-mender',
  'blue-copper-scalp-renewal-serum',
  'diamond-infusion-hair-serum',
  'diamond-infusion-deep-repair-mask',
  '10-second-speed-repair-mask',
  'mermaid-tears-holographic-mist'
];
LC.isSoldOut = (p) => LC.soldOutIds.includes(p.id);

LC.featureCardHTML = function (p) {
  const e = LC.escape;
  const url = LC.productUrl(p.id);
  const img = LC.blueImage(p);
  const copy = LC.featureCopy[p.id] || {};
  const kind = (LC.collections[p.category] || {}).name || 'Hair Care';
  const plus = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>';
  const soldOut = LC.isSoldOut(p);
  // Sold-out cards drop the add button: there is nothing to add
  const action = soldOut
    ? ''
    : p.price != null
      ? `<button class="fcard-add" type="button" data-add="${e(p.id)}" aria-label="Add ${e(p.name)} to bag">${plus}</button>`
      : `<a class="fcard-add" href="${url}" aria-label="View ${e(p.name)}">${plus}</a>`;
  return `
    <article class="fcard">
      <a class="fcard-media" href="${url}">
        ${soldOut ? '<span class="fcard-badge is-soldout">Sold Out</span>' : copy.badge ? `<span class="fcard-badge">${e(copy.badge)}</span>` : ''}
        <img src="${e(img.src)}" alt="${e(img.alt)}" loading="lazy" width="1200" height="1200">
      </a>
      <p class="fcard-meta">${e(kind)}</p>
      <h3 class="fcard-name"><a href="${url}">${e(p.name)}</a></h3>
      <div class="fcard-foot">
        <p class="fcard-price">${soldOut ? 'Sold out' : p.price != null ? LC.formatPrice(p.price).replace(/\.00$/, '') : 'Coming soon'}</p>
        ${action}
      </div>
    </article>`;
};

LC.findProduct = (id) => LC.products.find((p) => p.id === id);
LC.featured = () => LC.featuredIds.map(LC.findProduct).filter(Boolean);
// The blue-packaging photo for a product (images/sq/), falling back to its main photo
LC.blueImage = (p) => {
  const img = p.images.find((i) => i.src.indexOf('images/sq/') === 0) || p.images[0];
  return img ? { src: img.src, alt: img.alt, lifestyle: false } : LC.productImage(p);
};
LC.inCollection = (key) => {
  if (key === 'all') return LC.products.slice();
  const col = LC.collections[key];
  if (col && col.includes) {
    return LC.products.filter((p) => (col.includes.includes(p.category) && !(col.excludeIds || []).includes(p.id))
      || (col.alsoIds || []).includes(p.id));
  }
  return LC.products.filter((p) => p.category === key);
};
// The signature collection a product belongs to (for breadcrumbs)
LC.groupOf = (p) => LC.collectionOrder.find((k) => LC.inCollection(k).some((x) => x.id === p.id)) || p.category;
// Clean, crawlable URLs that mirror the Shopify store structure
LC.productUrl = (id) => `products/${id}.html`;
LC.collectionUrl = (key) => `collections/${key || 'all'}.html`;
LC.pageUrl = (handle) => `pages/${handle}.html`;
// Page parameters come from <body data-*> on prerendered pages, with a query-string fallback
LC.param = (name) => (document.body && document.body.dataset[name]) || new URLSearchParams(location.search).get(name);
LC.the = (p) => (['hair-care', 'treatments'].includes(p.category) || /beard oil/i.test(p.name) ? p.name : `the ${p.name}`);
LC.isPlural = (p) => /extensions$/i.test(p.name);
LC.formatPrice = (n) => '$' + Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
LC.escape = (value) => String(value).replace(/[&<>"']/g, (c) => (
  { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]
));

LC.collectionImage = function (key) {
  const col = LC.collections[key];
  if (col && col.image) return { src: col.image, alt: col.imageAlt, lifestyle: true };
  const withImage = LC.inCollection(key).find((p) => p.images.length);
  return withImage ? { src: withImage.images[0].src, alt: withImage.images[0].alt, lifestyle: false } : { src: 'images/h-1.jpg', alt: '', lifestyle: true };
};

// Product photo, falling back to the collection's lifestyle image when a product has none yet.
LC.productImage = function (p, index = 0) {
  if (p.images[index]) return { src: p.images[index].src, alt: p.images[index].alt, lifestyle: false };
  const fallback = LC.collectionImage(p.category);
  return { src: fallback.src, alt: `${p.name} (image coming soon)`, lifestyle: true };
};

LC.swatchColor = function (name) {
  const n = name.toLowerCase();
  const map = [
    [/marble/, 'linear-gradient(135deg,#f5f5f5 0%,#d9d9d9 45%,#fafafa 55%,#c9c9c9 100%)'],
    [/unicorn/, 'linear-gradient(135deg,#f7b6d2,#c7b8f5,#9fe3f0)'],
    [/rose gold/, 'linear-gradient(135deg,#f1c6b4,#c98f7a)'],
    [/hot pink/, '#e2458f'],
    [/pink/, '#f09ac0'],
    [/lilac|lavender/, '#c4b3e3'],
    [/purple/, '#7d4fa8'],
    [/turquoise/, '#3cbfc0'],
    [/peach/, '#f6bb9b'],
    [/red/, '#c2303a'],
    [/black/, '#111318']
  ];
  const hit = map.find(([re]) => re.test(n));
  return hit ? hit[1] : '#d9d4cc';
};

/* ---------- Hair extension shades: color swatches (hair photo swatches once added) ---------- */
LC.shadeHex = {
  '1': '#17120f', '1B': '#241b16', '2': '#33241c', '2B': '#3f2e24', '3': '#553b2b', '4': '#664632',
  '5': '#7a5f49', '6': '#86603f', '8': '#977050', '10': '#b9a88f', '16': '#c9956a', '18': '#b6a283',
  '22': '#c7a26c', '24': '#d6b57e', '27': '#b8834f', '30': '#9d6639', '33': '#7b3e27', '60': '#e9e1cf',
  '613': '#e7d4a3', '70': '#efe9dd', '99': '#5b2823'
};
LC.newShades = ['5'];
// Hair swatch photos live in images/shade-<code>.png (e.g. shade-4-27.png)
LC.hasShadePhotos = true;
LC.shadeSwatch = function (name) {
  const m = String(name).match(/^#\s*([\dA-Z]+)(?:\s*\/\s*([\dA-Z]+))?/i);
  if (!m) return { code: '', bg: LC.swatchColor(name), isNew: false };
  const a = m[1].toUpperCase();
  const b = m[2] ? m[2].toUpperCase() : '';
  const code = b ? `${a}/${b}` : a;
  const fill = b
    ? `linear-gradient(135deg, ${LC.shadeHex[a] || '#8a7360'} 0 50%, ${LC.shadeHex[b] || '#d9c49a'} 50% 100%)`
    : (LC.shadeHex[a] || '#8a7360');
  const photoPath = `images/shade-${code.replace('/', '-')}.png`;
  const photo = LC.asset ? LC.asset(photoPath) : photoPath;
  return {
    code,
    bg: LC.hasShadePhotos ? `url('${photo}') center / cover no-repeat, ${fill}` : fill,
    isNew: LC.newShades.includes(code)
  };
};

/* ---------- Benefit icons (inline SVG, stroke-based) ---------- */
LC.icons = {
  flame: '<path d="M12 3c2.8 3.2 5 5.9 5 9.2A5 5 0 0 1 7 12.2c0-2 1-3.6 2.4-5 .2 1.8 1.1 2.9 2.4 3.1-.4-2.5-.3-4.9.2-7.3Z"/>',
  ion: '<circle cx="12" cy="12" r="8.5"/><path d="M8.5 12h7"/><circle cx="19" cy="5" r="1"/><circle cx="4.5" cy="18.5" r="1"/>',
  plates: '<rect x="5" y="3" width="5.5" height="18" rx="2"/><rect x="13.5" y="3" width="5.5" height="18" rx="2"/><path d="M7.75 7v10M16.25 7v10"/>',
  thermo: '<path d="M14 14.8V5a2 2 0 1 0-4 0v9.8a4 4 0 1 0 4 0Z"/><path d="M12 9v7"/>',
  globe: '<circle cx="12" cy="12" r="9"/><path d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18"/>',
  swivel: '<path d="M20 12a8 8 0 1 1-2.34-5.66"/><path d="M20 4v4h-4"/>',
  feather: '<path d="M20 4C12 4 7 9 7 17v3"/><path d="M7 16c5 0 9-3 10.5-8"/><path d="M4 20l3-3"/>',
  shield: '<path d="M12 3l7 3v5c0 4.5-3 8.4-7 10-4-1.6-7-5.5-7-10V6l7-3Z"/><path d="M9 12l2 2 4-4"/>',
  snow: '<path d="M12 3v18M4.2 7.5l15.6 9M4.2 16.5l15.6-9"/>',
  curl: '<path d="M12 20a8 8 0 1 1 8-8c0 3.3-2.2 5.5-5 5.5S10 15.5 10 13s1.5-3.5 3-3.5"/>',
  wind: '<path d="M3 8h11a3 3 0 1 0-3-3"/><path d="M3 12h15a3 3 0 1 1-3 3"/><path d="M3 16h7"/>',
  brush: '<rect x="4" y="3" width="16" height="8" rx="3"/><path d="M8 11v3M12 11v3M16 11v3M12 14v7"/>',
  strand: '<path d="M8 3c-3 5 3 9 0 18"/><path d="M12 3c-3 5 3 9 0 18"/><path d="M16 3c-3 5 3 9 0 18"/>',
  drop: '<path d="M12 3s6 6.5 6 11a6 6 0 0 1-12 0c0-4.5 6-11 6-11Z"/>',
  leaf: '<path d="M5 19C5 10.5 11 5 20 4c-.5 9-6.5 15-15 15Z"/><path d="M5 19l7.5-7.5"/>',
  refresh: '<path d="M20 12a8 8 0 0 1-14.3 4.9"/><path d="M4 12a8 8 0 0 1 14.3-4.9"/><path d="M18.5 3v4.2h-4.2M5.5 21v-4.2h4.2"/>',
  check: '<circle cx="12" cy="12" r="9"/><path d="M8 12.5l2.5 2.5L16 9.5"/>',
  grid: '<rect x="4" y="4" width="7" height="7" rx="1.5"/><rect x="13" y="4" width="7" height="7" rx="1.5"/><rect x="4" y="13" width="7" height="7" rx="1.5"/><rect x="13" y="13" width="7" height="7" rx="1.5"/>',
  bag: '<path d="M5 8h14l-1 12H6L5 8Z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/>',
  ruler: '<rect x="3" y="8" width="18" height="8" rx="1.5"/><path d="M7 8v3M11 8v4M15 8v3"/>',
  sparkle: '<path d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8L12 3Z"/><path d="M18 16l.7 1.8 1.8.7-1.8.7L18 21l-.7-1.8-1.8-.7 1.8-.7L18 16Z"/>',
  play: '<path d="M8 5v14l11-7L8 5Z" fill="currentColor" stroke="none"/>'
};

LC.icon = (name) => `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${LC.icons[name] || LC.icons.sparkle}</svg>`;

LC.iconFor = function (text) {
  const rules = [
    [/cool-touch|cool tips|450|resistan|protect/i, 'shield'],
    [/glue|removable|clip-free|no damage|no rinse/i, 'check'],
    [/coordinated|routine|pairs with/i, 'leaf'],
    [/split end|strengthen|roots|\brepair\b|restores/i, 'shield'],
    [/cleans|fresh start|scalp|clarif/i, 'refresh'],
    [/caviar|keratin|biotin|shine|gloss|diamond|polish|finish/i, 'sparkle'],
    [/botanical|argan|jojoba|plant|natural/i, 'leaf'],
    [/peptide|powder|hydrat|moistur|condition|soft/i, 'drop'],
    [/infrared|heat technology/i, 'flame'],
    [/\bions?\b|ionic/i, 'ion'],
    [/plate|titanium|ceramic|tourmaline|barrel/i, 'plates'],
    [/temperature|heat setting|digital/i, 'thermo'],
    [/dual voltage|worldwide/i, 'globe'],
    [/swivel/i, 'swivel'],
    [/lightweight|ergonomic|comfort/i, 'feather'],
    [/cool|fan/i, 'snow'],
    [/attachment|interchangeable|\bset\b|duet|2-in-1|all-in-one|clip-in/i, 'grid'],
    [/curl|wave|twist|rounded/i, 'curl'],
    [/\bair(flow|styler)?\b|dryer|drying|motor|rpm|blow/i, 'wind'],
    [/bristle|brush|comb|detangl|vent/i, 'brush'],
    [/pouch|storage|travel|portable|compact|mini/i, 'bag'],
    [/inch|length|"/i, 'ruler'],
    [/human hair|remy|halo|shade/i, 'strand'],
    [/caviar|keratin|argan|oil|biotin|botanical|glycerin|panthenol|vitamin|extract/i, 'drop']
  ];
  const hit = rules.find(([re]) => re.test(text));
  return hit ? hit[1] : 'sparkle';
};

/* ---------- FAQs, built only from facts in the master sheet ---------- */
LC.faqsFor = function (p) {
  const faqs = [];
  const sentence = (s) => {
    const t = String(s).trim();
    const cap = t.charAt(0).toUpperCase() + t.slice(1);
    return /[.!?]$/.test(cap) ? cap : cap + '.';
  };
  const lower = (s) => (/^[A-Z]{2}/.test(s) ? s : s.charAt(0).toLowerCase() + s.slice(1));
  const add = (q, a) => {
    if (a && faqs.length < 10 && !faqs.some((f) => f.q === q)) faqs.push({ q, a: sentence(a) });
  };
  const highlight = (re) => p.highlights.find((h) => re.test(`${h.title} ${h.text}`));
  const feature = (re) => p.features.find((f) => re.test(f));
  const step = (re) => p.directions.find((d) => re.test(d));
  const isTool = ['flat-irons', 'blow-dryers', 'curling', 'travel'].includes(p.category);
  // Questions name the product the way people search for it; answers lead with the direct answer.
  const n = LC.the(p);
  const N = n.charAt(0).toUpperCase() + n.slice(1);
  const is = LC.isPlural(p) ? 'are' : 'is';
  const Is = is.charAt(0).toUpperCase() + is.slice(1);
  const it = LC.isPlural(p) ? 'they' : 'it';
  let h; let f; let s;

  if (feature(/dual voltage/i) || highlight(/dual voltage/i)) {
    h = highlight(/dual voltage/i);
    add(`${Is} ${n} dual voltage for international travel?`,
      `Yes, ${n} ${is} dual voltage. ${h && h.text ? sentence(h.text) + ' ' : ''}Depending on your destination, you may need a plug adapter`);
  }
  if ((h = highlight(/all hair types/i))) add(`Does ${n} work on all hair types?`, `Yes. ${h.text || h.title}`);
  if ((h = highlight(/keratin[^.]*safe|safe[^.]*keratin/i))) add(`${Is} ${n} safe for keratin-treated hair?`, `Yes. ${h.text || h.title}`);

  if (isTool) {
    if ((s = step(/heat protectant/i))) add(`Do I need a heat protectant with ${n}?`, `Yes. ${sentence(s)}`);
    if ((s = step(/lowest effective heat|heat setting/i))) add(`What heat setting should I use on ${n}?`, s);
    if ((f = feature(/temperature|heat settings?/i))) add(`Does ${n} have adjustable temperature?`, `Yes. ${N} features ${lower(f)}`);
    if ((f = feature(/attachment|interchangeable/i))) add(`What attachments come with ${n}?`, `${N} includes ${lower(f)}`);
    if ((s = step(/cool completely|cool fully|before storing|before storage/i))) add(`How do I store ${n} after styling?`, s);
  }

  if (p.category === 'extensions') {
    if ((f = feature(/human hair/i))) add(`${Is} ${n} real human hair?`, `Yes. ${N} ${is} made with ${lower(f)}`);
    if ((f = feature(/glue|heat needed/i))) add(`Do ${n} need glue or heat to apply?`, `No. ${f}`);
    if ((s = step(/remove before/i))) add(`Can I sleep, shower or swim in ${n}?`, s);
    if (highlight(/heat-styling/i)) add(`Can I heat style ${n}?`, `Yes, ${n} ${is} heat-styling friendly. Follow the included care instructions for washing and heat styling`);
    if ((s = step(/detangle/i))) add(`How do I prepare ${n} before wearing ${it === 'they' ? 'them' : 'it'}?`, s);
  }

  if (p.category === 'hair-care') {
    if ((h = highlight(/sulfate|paraben/i))) add(`${Is} ${n} sulfate-free and paraben-free?`, `Yes. ${h.text || h.title}`);
    const keyIngredients = p.features.filter((x) => /extract|oil|keratin|biotin|glycerin|panthenol|vitamin/i.test(x));
    if (keyIngredients.length) add(`What are the key ingredients in ${n}?`, `${N} is formulated with ${keyIngredients.map(lower).join('; ')}`);
    if ((s = step(/week|often|daily/i))) add(`How often should I use ${n}?`, s);
    if ((s = step(/follow with|pair/i))) add(`What should I use with ${n}?`, s);
    if (p.ingredients) add(`What ingredients are in ${n}?`, `The full ${p.name} ingredient list is in the Ingredients section on this page`);
  }

  if ((f = feature(/450|heat resistan/i))) add(`How much heat can ${n} handle?`, `${N} offers ${lower(f)}`);
  if (feature(/no rinse/i)) add(`Do I rinse out ${n}?`, `No. ${N} is a no-rinse formula`);
  if ((f = feature(/^size:/i))) add(`What size is ${n}?`, `${N} is ${f.replace(/^size:\s*/i, '')}`);
  if (p.category === 'treatments' && p.price == null) add(`When will ${n} be available?`, `Pricing and availability for ${n} are coming soon. Join the Inner Circle to hear first`);
  if (faqs.length < 3 && p.directions.length) add(`How do I use ${n}?`, p.directions[0]);
  if (faqs.length < 3 && p.benefits.length) {
    add(`What are the benefits of ${n}?`, p.benefits.map((b) => (b.text ? `${b.title}: ${b.text}` : b.title)).join(' '));
  }

  // Store policies, from the Le Chic Beauty FAQ and warranty policy
  const P = LC.storeFaqs(p);
  const isHairTool = isTool || (p.category === 'grooming' && /brush|straightener/i.test(p.name));
  if (p.category === 'extensions') {
    add(...P.remy);
    if (/halo/i.test(p.name)) { add(...P.haloDamage); add(...P.haloHold); add(...P.haloLast); }
    add(...P.color);
  }
  if (isHairTool) add(...P.warranty);
  add(...P.shipping);
  add(...P.returns);
  return faqs;
};

LC.storeFaqs = (p) => {
  const n = p ? LC.the(p) : 'your order';
  const N = n.charAt(0).toUpperCase() + n.slice(1);
  return {
    warranty: [`Does ${n} come with a warranty?`, `Yes. ${N} is covered by the Le Chic Beauty Limited Lifetime Warranty when purchased from Le Chic Beauty or an authorized retailer and registered within 14 days of purchase. Keep your proof of purchase for any claim`],
    shipping: [`How fast does ${n} ship?`, `Le Chic Beauty typically ships orders within 1–2 business days of purchase, with tracking. You’ll receive a confirmation email with your tracking number once it ships`],
    returns: [`What is the return policy for ${n}?`, `Orders placed directly with Le Chic Beauty can be returned for a refund or exchange within 30 days of delivery. Return shipping is paid by the customer; a 10% restocking fee applies to unused, unopened items and a 30% fee to used or opened items. Purchases from other retailers follow that retailer’s policy`],
    remy: ['What is Remy human hair?', 'Remy hair is 100% never-processed, “virgin” human hair that keeps its cuticle layer, with every strand flowing in its natural direction to help prevent tangling and breakage'],
    haloDamage: ['Do halo hair extensions damage your hair?', 'No. Le Chic Beauty halo extensions fit without weaving, clips or glue. A fitted wire sits beneath your own hair, so you can add length and volume in minutes with a damage-free application'],
    haloHold: ['How do halo hair extensions stay in place?', 'The halo wire sits about one to three inches behind your hairline. Once your natural hair is pulled over the wire, its weight keeps the halo secure. Optional clips are included for extra hold'],
    haloLast: ['How long do Le Chic Beauty halo extensions last?', 'With regular care, Le Chic Beauty halo extensions should last nine months or longer, depending on how often they’re worn. As they’re human hair, there is no guaranteed time frame'],
    color: [`Can you color ${n}?`, `Yes. For a seamless match, have a stylist color ${n}. If coloring at home, do a strand test on a discreet section first`]
  };
};

LC.howToPoster = function (p) {
  // Prefer each product's own photo so How-to / film cards are distinct (not one lifestyle shot per category)
  const own = LC.productImage(p);
  if (own && own.src && !own.lifestyle) return own.src;
  const posters = {
    'flat-irons': 'images/t-iron.jpg',
    'blow-dryers': 'images/t-dryer.jpg',
    curling: 'images/t-wand.jpg',
    travel: 'images/t-ritual.jpg',
    'hair-care': 'images/m-chloe.jpg',
    treatments: 'images/f-mermaid.jpg',
    extensions: 'images/m-vivienne.jpg',
    accessories: 'images/t-ritual.jpg'
  };
  return posters[p.category] || (own && own.src) || 'images/h-1.jpg';
};

/* ---------- Product card ---------- */
LC.cardHTML = function (p, opts) {
  const e = LC.escape;
  const o = opts && typeof opts === 'object' ? opts : {};
  const url = LC.productUrl(p.id);
  // Hair tools that come in several colors show their black finish on cards
  const black = p.options.length > 1 && LC.collections.tools.includes.includes(p.category)
    ? p.options.find((x) => /black/i.test(x.name) && x.image)
    : null;
  const img = o.image || (black ? { src: black.image, alt: `${p.name} in ${black.name}`, lifestyle: false } : LC.productImage(p));
  const count = p.options.length;
  const optionWord = p.optionLabel === 'Shade' ? 'shades' : 'colors';

  let action;
  if (LC.isSoldOut(p)) action = `<a class="add-btn is-soldout" href="${url}">Sold Out</a>`;
  else if (p.price == null) action = `<a class="add-btn" href="${url}">View</a>`;
  else if (p.inShop === false) action = `<a class="add-btn" href="${url}">Coming Soon</a>`;
  else if (p.available === false) action = `<a class="add-btn" href="${url}">Sold Out</a>`;
  else if (count > 1) action =`<a class="add-btn" href="${url}">Choose ${p.optionLabel === 'Shade' ? 'Shade' : 'Color'}</a>`;
  else action = `<button class="add-btn" type="button" data-add="${e(p.id)}"${count === 1 ? ` data-option="${e(p.options[0].name)}"` : ''}>Add to Bag</button>`;

  // Colors show as tiny swatch dots; extension shades as a count
  let optionsHTML = '';
  if (count > 1 && p.optionLabel !== 'Shade') {
    const dots = p.options.slice(0, 5).map((o) => `<span class="mini-dot" style="--c:${LC.swatchColor(o.name)}" title="${e(o.name)}"></span>`).join('');
    optionsHTML = `<p class="product-options" aria-label="${count} ${optionWord}">${dots}${count > 5 ? `<span class="mini-more">+${count - 5}</span>` : ''}</p>`;
  } else if (count > 1) {
    optionsHTML = `<p class="product-options">${count} ${optionWord}</p>`;
  }

  return `
    <article class="product-card" id="card-${e(p.id)}" data-collection="${e(p.category)}">
      <div class="product-visual">
        <a class="product-media" href="${url}">
          <img src="${e(img.src)}" alt="${e(img.alt)}" loading="lazy"${img.lifestyle ? ' class="is-lifestyle"' : ''}>
        </a>
        ${action}
      </div>
      <div class="product-info">
        <p class="product-collection">${e(LC.collections[p.category].name)}</p>
        <h3><a href="${url}">${e(p.name)}</a></h3>
        <div class="product-meta-row">
          <p class="price">${p.price != null ? LC.formatPrice(p.price) : '<span class="price-soon">Price coming soon</span>'}</p>
          ${optionsHTML}
        </div>
      </div>
    </article>`;
};

/* ---------- Header product search ---------- */
LC.searchText = (s) => String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
  .replace(/[”“″]/g, '"').replace(/[’‘']/g, '');
LC.searchIndex = null;
LC.buildSearchIndex = function () {
  const groups = {};
  LC.collectionOrder.forEach((key) => LC.inCollection(key).forEach((p) => {
    (groups[p.id] = groups[p.id] || []).push(LC.collections[key].name);
  }));
  LC.searchIndex = LC.products.map((p) => ({
    p,
    name: LC.searchText(p.name),
    text: LC.searchText([
      p.name,
      (LC.collections[p.category] || {}).name,
      (groups[p.id] || []).join(' '),
      p.features.join(' '),
      p.options.map((o) => o.name).join(' '),
      p.description
    ].join(' '))
  }));
  return LC.searchIndex;
};
LC.searchProducts = function (query, limit = 8) {
  const tokens = LC.searchText(query).split(/\s+/).filter(Boolean);
  if (!tokens.length) return [];
  return (LC.searchIndex || LC.buildSearchIndex())
    .filter((x) => tokens.every((t) => x.text.includes(t)))
    .map((x) => ({ p: x.p, score: (x.name.startsWith(tokens[0]) ? 3 : 0) + tokens.filter((t) => x.name.includes(t)).length * 2 }))
    .sort((a, b) => b.score - a.score || a.p.name.localeCompare(b.p.name))
    .slice(0, limit)
    .map((x) => x.p);
};

// Search icon in the header that opens a search bar with instant product results
LC.initSearch = function () {
  const header = document.querySelector('.site-header');
  const actions = header && header.querySelector('.header-actions');
  if (!actions || header.querySelector('.search-btn')) return;
  const e = LC.escape;
  const isShop = Boolean(window.LC_SHOP_PRODUCTS);
  const icon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="6.5"/><path d="M16 16l4.5 4.5"/></svg>';
  const popular = [['Flat Irons', 'flat iron'], ['Blow Dryers', 'dryer'], ['Repairing Caviar', 'caviar'], ['Halo Extensions', 'halo'], ['Curling Wands', 'twister']];

  const btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'icon-btn search-btn';
  btn.setAttribute('aria-label', 'Search products');
  btn.setAttribute('aria-expanded', 'false');
  btn.setAttribute('aria-controls', 'site-search');
  btn.innerHTML = icon;
  actions.insertBefore(btn, actions.firstChild);

  const panel = document.createElement('div');
  panel.className = 'site-search';
  panel.id = 'site-search';
  panel.hidden = true;
  panel.innerHTML = `
    <div class="container site-search-inner">
      <form class="search-form" role="search" action="${isShop ? '/search' : e(LC.collectionUrl('all'))}" method="get">
        <label for="site-search-input" class="sr-only">Search Le Chic Beauty</label>
        <span class="search-form-icon">${icon}</span>
        <input id="site-search-input" name="q" type="search" autocomplete="off" placeholder="Search hair tools, hair care, extensions…">
        <button type="button" class="search-close" aria-label="Close search">×</button>
      </form>
      <div class="search-popular"><span>Popular</span>${popular.map(([label, q]) => `<button type="button" class="search-chip" data-q="${e(q)}">${e(label)}</button>`).join('')}</div>
      <p class="search-status sr-only" aria-live="polite"></p>
      <div class="search-results"></div>
    </div>`;
  header.appendChild(panel);

  const input = panel.querySelector('input');
  const results = panel.querySelector('.search-results');
  const status = panel.querySelector('.search-status');
  const popularEl = panel.querySelector('.search-popular');
  const render = () => {
    const q = input.value.trim();
    popularEl.hidden = q.length > 0;
    if (!q) { results.innerHTML = ''; status.textContent = ''; return; }
    const found = LC.searchProducts(q, 8);
    status.textContent = found.length ? `${found.length} product${found.length === 1 ? '' : 's'} found` : 'No products found';
    results.innerHTML = found.length
      ? `<ul class="search-list">${found.map((p) => {
        const img = LC.blueImage ? LC.blueImage(p) : LC.productImage(p);
        const col = LC.collections[p.category] || {};
        return `<li><a class="search-item" href="${LC.productUrl(p.id)}">
          <span class="search-thumb"><img src="${e(img.src)}" alt="" loading="lazy"></span>
          <span class="search-copy"><small>${e(col.name || '')}</small><strong>${e(p.name)}</strong><em>${p.price != null ? LC.formatPrice(p.price) : 'Coming soon'}</em></span>
        </a></li>`;
      }).join('')}</ul>${isShop ? `<a class="link-arrow search-all" href="/search?q=${encodeURIComponent(q)}">See all results for “${e(q)}” <span aria-hidden="true">→</span></a>` : ''}`
      : `<p class="search-empty">No products match “${e(q)}”. Try “flat iron”, “caviar” or “halo”.</p>`;
  };
  const open = () => {
    panel.hidden = false;
    btn.setAttribute('aria-expanded', 'true');
    setTimeout(() => input.focus(), 30);
  };
  const close = () => {
    panel.hidden = true;
    btn.setAttribute('aria-expanded', 'false');
  };
  btn.addEventListener('click', () => (panel.hidden ? open() : close()));
  panel.querySelector('.search-close').addEventListener('click', () => { close(); btn.focus(); });
  input.addEventListener('input', render);
  popularEl.addEventListener('click', (ev) => {
    const chip = ev.target.closest('.search-chip');
    if (!chip) return;
    input.value = chip.dataset.q;
    render();
    input.focus();
  });
  panel.querySelector('form').addEventListener('submit', (ev) => {
    if (isShop) return; // Shopify shows its full search results page
    ev.preventDefault();
    const first = LC.searchProducts(input.value, 1)[0];
    if (first) location.href = LC.productUrl(first.id);
  });
  document.addEventListener('keydown', (ev) => { if (ev.key === 'Escape' && !panel.hidden) { close(); btn.focus(); } });
  document.addEventListener('click', (ev) => {
    if (!panel.hidden && !panel.contains(ev.target) && !btn.contains(ev.target)) close();
  });
};

/* ---------- Journal ---------- */
/* ---------- Subscribe & Save (hair care only) ---------- */
LC.subscription = { discount: 0.15, cadence: 'every 8 weeks' };
LC.subPrice = (price) => Math.round(price * (1 - LC.subscription.discount) * 100) / 100;

LC.journal = () => (window.LC_JOURNAL || []).slice().sort((a, b) => b.date.localeCompare(a.date));
LC.articleUrl = (slug) => `blogs/news/${slug}.html`;
LC.journalUrl = 'blogs/news/index.html';
LC.formatDate = (iso) => new Date(iso + 'T12:00:00').toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
LC.storyCardHTML = function (a) {
  const e = LC.escape;
  return `
    <a class="story-card" href="${LC.articleUrl(a.slug)}">
      <div class="story-media"><img src="${e(a.cover)}" alt="${e(a.coverAlt)}" loading="lazy"></div>
      <p class="story-meta"><span>${e(a.category)}</span><span>${a.minutes} min read</span></p>
      <h3>${e(a.title)}</h3>
      <p class="story-excerpt">${e(a.excerpt)}</p>
      <span class="link-arrow">Read <span aria-hidden="true">→</span></span>
    </a>`;
};

LC.collectionTileHTML = function (key) {
  const e = LC.escape;
  const col = LC.collections[key];
  const img = LC.collectionImage(key);
  return `
    <a href="${LC.collectionUrl(key)}" class="cat-tile">
      <img src="${e(img.src)}" alt="${e(img.alt)}" loading="lazy">
      <div class="cat-copy">
        <span class="cat-eyebrow">${e(col.eyebrow || col.tagline)}</span>
        <h3>${e(col.name)}</h3>
        <span class="cat-link">Discover</span>
      </div>
    </a>`;
};
